import Joyride, { ACTIONS, CallBackProps, EVENTS, STATUS } from "react-joyride";
import React from "react";
import { I18N } from "oc-I18N";
import * as Doms from "oc-ui/Doms";

export function Joyrider({ stepIndex, setStepIndex, steps, width, ...props }) {
  const locale = {
    back: I18N("Zurück"),
    close: I18N("Schließen"),
    last: I18N("Fertig"),
    next: I18N("Weiter"),
    open: I18N("Open the dialog"),
    skip: I18N("Überspringen"),
  };
  const style = {
    options: {
      arrowColor: "#fff",
      backgroundColor: "#fff",
      beaconSize: 42,
      overlayColor: "rgba(0, 0, 0, 0.5)",
      primaryColor: Doms.getCssVar("--color-primary-0"),
      spotlightShadow: "0 0 15px rgba(0, 0, 0, 0.5)",
      textColor: "#333",
      width,
      zIndex: 100,
    },
  };

  if (stepIndex < 0 || stepIndex >= steps.length) {
    return null;
  }

  function handleSteps(data: CallBackProps) {
    const { action, index, status, type } = data;
    APP.logUserAction({ action: "joyride", value: index }, { cached: true });
    if (
      ([ACTIONS.CLOSE, ACTIONS.SKIP] as string[]).includes(action) ||
      ([STATUS.FINISHED, STATUS.SKIPPED] as string[]).includes(status)
    ) {
      setStepIndex(-1);
    } else if (([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND] as string[]).includes(type)) {
      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    }
  }

  return (
    <div className="grid-fullscreen" style={{ pointerEvents: "none" }}>
      {/* @ts-ignore //TODO: remove when Joyride has proper typing */}
      <Joyride
        continuous={true}
        showSkipButton={true}
        spotlightClicks={true}
        // hier ist ein Bug: sobald disableCloseOnEsc={true} gesetzt wird, wird beim nächsten Aufruf von Joyride das Popup sofort wieder geschlossen
        disableCloseOnEsc={true}
        hideBackButton={true}
        hideCloseButton={true}
        styles={style}
        locale={locale}
        steps={steps}
        stepIndex={stepIndex}
        run={stepIndex >= 0 && stepIndex < steps.length}
        callback={handleSteps}
        {...props}
      />
    </div>
  );
}
